"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackOneStepExtensionDefinition = void 0;
const WidgetExtensionPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPlugin");
const WidgetExtensionPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPluginDefinition");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const configs_1 = require("../../configs/configs");
const StepTypes_1 = require("../../Enum/StepTypes");
class BackOneStepExtension extends WidgetExtensionPlugin_1.default {
    /**
     * Creates asset cleanup extension.
     *
     * @param definition
     * @param assetManager
     */
    constructor(definition) {
        super(definition);
        this.stepStack = [];
    }
    /**
     * @inheritDoc
     */
    static create(definition, container) {
        return new this(definition);
    }
    /**
     * @inheritDoc
     */
    initialize(widget) {
        this.widget = widget;
        let eventContainer = this.widget.getEventContainer();
        eventContainer.on(WidgetEvents_1.WidgetEvents.STEP_READY, this.registerBackFunctionality.bind(this));
        return Promise.resolve();
    }
    /**
     * Registers back action.
     * Regardless of the flow taken, back from SELECT_VEHICLE must always go to SEARCH_VEHICLE_VRN_AND_DETAILS
     */
    registerBackFunctionality(step) {
        if (step === StepTypes_1.StepTypes.SELECT_VEHICLE && this.stepStack.length <= 1) {
            this.stepStack.push(StepTypes_1.StepTypes.SEARCH_VEHICLE_VRN_AND_DETAILS);
        }
        this.stepStack.push(step);
        const elements = this.widget.getContainer().querySelectorAll(`[data-px-action="${configs_1.configs.actions.prevStep}"]`);
        const stepsWithBack = [
            StepTypes_1.StepTypes.CAR_CONDITION,
            StepTypes_1.StepTypes.CUSTOMER,
            StepTypes_1.StepTypes.SELECT_VEHICLE,
        ];
        if (stepsWithBack.includes(this.widget.getCurrentStep().getDefinition().getId())) {
            for (let i = 0, element; element = elements[i]; ++i) {
                element.addEventListener("click", this.goBackOneStep.bind(this));
            }
        }
    }
    /**
     * Go to the previous step.
     */
    goBackOneStep() {
        if (this.stepStack.length >= 2) {
            this.stepStack.pop();
            const previousStepId = this.stepStack.pop();
            this.widget.setStep(previousStepId);
        }
        else {
            this.widget.setPreviousStep();
        }
    }
}
exports.default = BackOneStepExtension;
exports.BackOneStepExtensionDefinition = new WidgetExtensionPluginDefinition_1.default({
    id: "back_one_step",
    class: BackOneStepExtension
});
